export default {
    "language": "en",
    "command": "SUBMIT_TRANSACTION",
    "merchant": {
        "apiKey": "",
        "apiLogin": ""
    },
    "transaction": {
        "order": {
            "accountId": "",
            "referenceCode": "payment_test_00000001",
            "description": "payment test",
            "language": "es",
            "signature": "",
            "notifyUrl": "",
            "additionalValues": {
                "TX_VALUE": {
                    "value": 0,
                    "currency": "",
                }
            },
            "buyer": {
                "merchantBuyerId": "1",
                "fullName": '',
                "emailAddress": "",
                "contactPhone": "",
                "dniNumber": "",
                "shippingAddress": {
                    "street1": "",
                    "street2": "",
                    "city": "",
                    "state": "",
                    "country": "",
                    "postalCode": "",
                    "phone": ""
                }
            },
            // "shippingAddress": {
            //     "street1": "",
            //     "street2": "",
            //     "city": "",
            //     "state": "",
            //     "country": "",
            //     "postalCode": "",
            //     "phone": ""
            // }
        },
        "payer": {
            "merchantPayerId": "1",
            "fullName": "",
            "emailAddress": "",
            "contactPhone": "",
            "dniNumber": "",
            "billingAddress": {
                "street1": "",
                "street2": "",
                "city": "",
                "state": "",
                "country": "",
                "postalCode": "",
                "phone": ""
            }
        },
        "creditCard": {
            "number": "",
            "securityCode": "",
            "expirationDate": "",
            "name": ""
        },
        "extraParameters": {
            "INSTALLMENTS_NUMBER": 1
        },
        "type": "AUTHORIZATION_AND_CAPTURE",
        "paymentMethod": "",
        "paymentCountry": "",
        "deviceSessionId": "",
        "ipAddress": "127.0.0.1",
        "cookie": "",
        "userAgent": "Mozilla/5.0 (Windows NT 5.1; rv:18.0) Gecko/20100101 Firefox/18.0"
    },
    "test": false
};
